import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, IconButton, Tooltip} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
import moment from 'moment';
import XLSX from 'xlsx';
import ExcelLogo from '../assets/icons8-export-excel-24.png';

export default class OrphanQuery extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            error_message: '',
            querying: true,
            pending_assessments_array: [],
        }

        this.datasheetFieldSpecs = [
            { field: 'rom_code', headerName: 'Manager Code', align: 'center',width: 125},
            { field: 'employees', headerName: '# Employees Assigned', headerAlign: 'center', align: 'center',width: 250, sortable: false}
        ]
    }

    componentDidMount = () => {

        Gserv.sendCommand('query_orphan_employees',this.props.gwt)
        .then(reply=>{
            // console.log('query_pending_assessments reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_orphan_employees) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_orphan_employees) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.setState({querying:false, pending_assessments_array:reply.Records?reply.Records : []});
            }
        });
    };

    resetMe = () => {
        this.setState({error: false,error_message: '',querying: true, pending_assessments_array: []});
        this.componentDidMount();
    }

    exportMe = () => {
        // console.log('called exportMe...');
        if (this.state.pending_assessments_array.length>0){
            const dateStr = new moment().format("YYYY-MM-DD");
            var ws = XLSX.utils.json_to_sheet(this.state.pending_assessments_array);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Invalid Manager Codes' + dateStr);
            //Write to browser
            XLSX.writeFile(wb,'TMS Export - Invalid Manager Codes as at ' + dateStr + '.xlsx');
        }
    }

    render() {return(
        <Grid
            container
            direction='column'
            // justifyContent='flex-start'
            // alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    width:400
                }}
            >

                <Grid
                    container
                    // style={{backgroundColor:'yellow'}}
                    justifyContent='center'
                    alignContent='center'
                >
                    <Typography
                        style={{padding:10}}
                    >
                        Invalid Manager Codes with Employees Assigned
                    </Typography>
                    &nbsp;&nbsp;
                    <IconButton 
                        aria-label='Export to Excel'
                        onClick={this.exportMe}
                        disabled={this.state.pending_assessments_array.length===0}
                    >
                        <Tooltip title="Export to Excel">
                            <img
                                src={ExcelLogo}
                                alt={'MS Excel'}
                                // height={78}
                                // width={161}
                            />
                        </Tooltip>
                    </IconButton>
                </Grid>

                {/* Datagrid goes here */}
                <DatasheetView 
                    dataset={this.state.pending_assessments_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={false}
                    edit={false}
                    handleDelete={null}
                    handleEdit={null}
                    loading={this.state.querying}
                    deleteHeaderName={''}
                    pagesize={10}
                    height={400}
                />

            </Paper>
            </Grid>

            <Grid item>
                <Typography color='secondary' style={{Width:400,maxWidth:400, textAlign:'center'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

        </Grid>
    )}
    
}